import * as React from 'react';
import { SVGProps } from 'react';

const FinishTransactionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_7808_198808"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={40}
      height={40}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5 8C23.5 12.4178 27.0822 16 31.5 16C35.9177 16 39.5 12.4178 39.5 8C39.5 3.58222 35.9177 0 31.5 0C27.0822 0 23.5 3.58222 23.5 8ZM34.4295 5.19492L35.6663 6.43302L30.6669 11.5263L27.6663 8.61714L28.9044 7.37651L30.6669 9.05016L34.4295 5.19492ZM0.388855 0V40H18.5031C24.126 40 35.9444 27.9606 35.9444 23.9771V17.4997C34.8371 17.9327 33.6384 18.2019 32.3888 18.2908V22.5727C32.3888 29.4171 21.7222 26.6667 21.7222 26.6667C21.7222 26.6667 24.4206 36.6667 17.0327 36.6667H3.94441V3.33333H20.8333C21.3882 2.08381 22.1895 0.96 23.1723 0H0.388855ZM9.27775 10.6667V12.4444H20.8333C20.5946 11.8756 20.4117 11.2787 20.2669 10.6667H9.27775ZM9.27775 16V17.7778H25.3615C24.5615 17.2737 23.8276 16.6794 23.1723 16H9.27775ZM9.27775 23.1111H27.0555V21.3333H9.27775V23.1111Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_7808_198808)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-5.95825 46.3493H45.8513V-6.34912H-5.95825V46.3493Z"
        fill="#615A5A"
      />
    </g>
  </svg>
);
export default FinishTransactionIcon;
